import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import _size from 'lodash/size'
import { compose } from 'recompose'
import { connect as connectRedux } from 'react-redux'
import { getParagraphs } from '../../services/detail/index'
import { truncate } from '../../theme/web-app/index'
import Button, { TYPES } from '../Button/index'

/**
 * The read more, read less component used for truncating text
 * and providing the read more button to show the full text
 * @param {Object} props - The props
 * @param {String} props.text - The description text
 * @param {Map} props.staticText - The static text
 * @param {Number} props.maxLength - The maximum length of the string before
 * the read more link shows
 * @param {Number} props.truncateBuffer - The truncation buffer. This allows a second value
 * to help make decisions for determining whether or not to show the read more link.
 * This helps with not having just a few characters show after clicking the read more link.
 * @returns {JSX.Element} The ReadMoreLess component
 */
const ReadMoreLess = (props) => {
  const {
    text,
    staticText,
    maxLength,
    truncateBuffer,
  } = props
  const [isOpen, setIsOpen] = useState(false)
  const textLength = _size(text)
  const textLengthMaxLengthDiff = textLength - maxLength
  const showReadMore = textLength > maxLength && textLengthMaxLengthDiff > truncateBuffer
  const buttonText = isOpen ? staticText.get('btnLess') : staticText.get('btnMore')

  const handleClick = () => {
    setIsOpen((currentValue) => !currentValue)
  }

  if (!text) {
    return null
  }

  return (
    <div className="read-more-less">
      {
        !showReadMore || isOpen
          ? getParagraphs(text)
          : getParagraphs(truncate(text, maxLength))
      }
      {
        showReadMore
          ? <Button
              type={TYPES.LINK}
              className="read-more-less__button"
              onClick={handleClick}
            >
              {buttonText}
            </Button>
          : null
      }
    </div>
  )
}

ReadMoreLess.propTypes = {
  text: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  truncateBuffer: PropTypes.number,
}

ReadMoreLess.defaultProps = {
  text: '',
  maxLength: 600,
  truncateBuffer: 100,
}

export default compose(
  connectRedux(
    (state) => {
      return {
        staticText: state.staticText.getIn(['data', 'readMoreLess', 'data'], Map()),
      }
    },
  ),
)(ReadMoreLess)
